import { t } from '@lingui/core/macro';
import { ButtonGroup, IconButton } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { Container, IconContainer, StyledInput } from './styled';
export function QueryField(props) {
    const { placeholder, action, onClear, onChange, value, loading, disabled, name } = props;
    const defaultPlaceholder = t({ message: 'Search', comment: 'Insights: Query filter placeholder' });
    return (<ButtonGroup>
      <Container>
        <IconContainer>
          <Falcon icon="magnifying-glass" $color="text.100"/>
        </IconContainer>
        <StyledInput placeholder={placeholder || defaultPlaceholder} onChange={onChange} value={value} disabled={disabled} name={name}/>
        <IconButton type="button" size="xs" appearance="ghost" onClick={onClear} disabled={!(value === null || value === void 0 ? void 0 : value.length) || loading || disabled}>
          <Falcon icon="xmark"/>
        </IconButton>
      </Container>
      {action}
    </ButtonGroup>);
}
